

require('../create-password/directive');

require('../password-recovery/directive');

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/auth/index', 'components/xo-models/src/checkout/index'], function ($, angular, squid, template) {

    return angular.module('xo-login-overlay.directive', ['squid', 'xomodel.checkout']).directive('xoLoginOverlay', function () {

        return {
            template: template,
            scope: {
                token: '=',
                stateInfo: '=',
                modalCallback: '='
            },
            controller: function controller($scope, $rootScope, $state, $element, $feature, $timeout, $logger, $util, $AuthModel, $CheckoutSessionModel, $CheckoutCartModel) {

                $scope.autoLogin = false;
                $scope.ulEligibility = true;
                $scope.auth = $AuthModel.instance();

                var stateInfo = {};
                var subFlowTitles = {
                    addCard: 'loginAddCard',
                    bank: 'loginAddBank',
                    addShipping: 'loginAddAddress',
                    deleteShipping: 'loginDeleteAddress',
                    confirmUpop: 'loginConfirmUpop',
                    redirectToCape: 'loginApplyCredit',
                    sepaAgreement: 'riskyLoginSepa',
                    applyPPC: 'loginApplyCredit',
                    DEFAULT: 'loginTitle'
                };

                var cancelInsufficientPermission = $rootScope.$on('$insufficientPermission', function (event, data) {
                    $scope.showOverlay = true;

                    $('#wrapper #spinner').hide();

                    stateInfo = data;

                    var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');

                    if (subFlowName) {
                        $scope.subFlowName = subFlowName;
                        $scope.subFlowTitleKey = 'login.' + subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;
                    }

                    $scope.createPassword = $feature('pomaPasswordRecovery') && $scope.auth.password_less;
                    $scope.passwordRecovery = false;
                    if ($scope.createPassword) {
                        $logger.info('checkout_fpti', {
                            from: getFptiStateName(),
                            to: 'prepare_quick_security_check'
                        });
                    } else {
                        $logger.info('checkout_fpti', {
                            from: getFptiStateName(),
                            to: 'prepare_login_step_up_AUTH'
                        });
                    }

                    $timeout(function () {
                        $element.addClass('overlayOpen');
                    });
                });

                $scope.$on('$destroy', cancelInsufficientPermission);

                var hideOverlay = function hideOverlay() {
                    $('#wrapper #spinner').attr('style', '');
                    $element.removeClass('overlayOpen');
                    return $timeout(function () {
                        $scope.showOverlay = false;
                    }, 300);
                };

                function getFptiStateName() {
                    if ($scope.createPassword) {
                        return 'quick_security_check';
                    } else if ($scope.passwordRecovery) {
                        return 'password_recovery';
                    } else {
                        return 'LOGIN_STEP_UP_AUTH';
                    }
                }

                function logCancel() {
                    $logger.info('checkout_fpti', {
                        from: getFptiStateName(),
                        to: 'process_user_cancel'
                    });
                }

                $scope.hideModal = function (event) {
                    event.preventDefault();
                    logCancel();
                    hideOverlay();
                    $state.go(stateInfo.oldState);
                };

                $scope.onCreatePassword = function () {
                    $rootScope.$emit('loading');
                    $scope.passwordRecovery = true;
                };

                $scope.onPasswordRecoveryReady = function () {
                    $rootScope.$emit('loaded');
                    $scope.createPassword = false;
                };

                $scope.onCompletePasswordRecovery = function () {
                    $scope.passwordRecovery = false;
                };

                $scope.onPasswordRecovery = function () {
                    $scope.auth.password_less = false;
                };

                $scope.onSuccess = function () {
                    var checkoutSession = $CheckoutSessionModel.instance($scope.token);
                    var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
                    return checkoutSession.action('create', {
                        data: {
                            baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                        },
                        success: function success() {
                            if (stateInfo.pageOnOverlay) {
                                $state.go(stateInfo.newState, { fromLoginOverlay: true });
                                $scope.showOverlay = false;
                            } else {
                                hideOverlay().then(function () {
                                    $state.go(stateInfo.newState);
                                });
                            }

                            $logger.info('checkout_fpti', {
                                from: getFptiStateName(),
                                to: 'process_login_step_up_AUTH'
                            });
                        }
                    })['finally'](function () {
                        hideOverlay();
                    });
                };
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-login-components/src/login-overlay/directive.js
 ** module id = 518
 ** module chunks = 1
 **/